const Profile = () => {
  return (
    <div className="font-black flex justify-around">
      <div>
        <h1> Anubhav baranwal</h1>
      </div>
    </div>
  );
};

export default Profile;
